export default __webpack_public_path__ + "static/media/tripleLine.c5c5fc5c.svg";